import { Box, Typography } from "@mui/material";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import TextIntegrationStyle from "../../TextIntegrationStyle";

const ServerOwnershipView = ({ entityData }) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2} pb={2}>
      {entityData?.servicenow_cmdb_data?.owning_service_owning_organization && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Owning Organization</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"12px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={
                entityData?.servicenow_cmdb_data
                  ?.owning_service_owning_organization
              }
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.owning_service_owned_by && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Owned By</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"12px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.servicenow_cmdb_data?.owning_service_owned_by}
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.owning_service_managed_by && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Managed By</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"12px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={
                entityData?.servicenow_cmdb_data?.owning_service_managed_by
              }
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.it_application_owner && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>IT Application Owner</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"12px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.servicenow_cmdb_data?.it_application_owner}
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.owning_service_assignment_group && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Assignment Group</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"12px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={
                entityData?.servicenow_cmdb_data
                  ?.owning_service_assignment_group
              }
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.owning_company_sys_id && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Owning Company</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"12px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.servicenow_cmdb_data?.owning_company_sys_id}
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.used_by_companies && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Used By Companies</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"12px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.servicenow_cmdb_data?.used_by_companies}
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.owning_service_used_by_companies && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>
              Service Used By Companies
            </Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"12px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={
                entityData?.servicenow_cmdb_data
                  ?.owning_service_used_by_companies
              }
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ServerOwnershipView;
